import store from 'client/store';

const DeviceInvestigativePages = () => import('client/HomePageV2/components/DeviceInvestigativePages.vue');
const HomeMainPanelV2 = () => import('client/HomePageV2/HomeMainPanel.vue');
const HomeSetting2ColumnPanel = () => import('client/HomePageV2/HomeSetting2ColumnPanel.vue');
const ViewAll = () => import('client/HomePageV2/components/ViewAll.vue');
const ViewAllDevices = () => import('client/HomePageV2/components/ViewAllDevices.vue');
const ViewAllOthers = () => import('client/HomePageV2/components/ViewAllOthers.vue');
const ViewAllWithoutActions = () => import('client/HomePageV2/components/ViewAllWithoutActions.vue');

export default [
  {
    path: '/home',
    beforeEnter: (to, from, next) => {
      const showOnboarding = store.getters['OnboardingModule/getShowOnboarding'];

      if (showOnboarding) {
        next({ path: '/onboarding' });
      } else {
        next();
      }
    },
    name: 'home',
    meta: {
      title: 'Home',
    },
    components: {
      loadLegacyStyles: false,
      mainPanel: HomeMainPanelV2,
    },
  },
  {
    path: '/home/settings',
    name: 'home settings',
    meta: {
      title: 'Home',
    },
    components: {
      loadLegacyStyles: false,
      mainPanel: HomeSetting2ColumnPanel,
    },
  },
  {
    path: '/viewall/:widgetName',
    name: 'ViewAll',
    meta: {
      title: 'Dashboard',
    },
    components: {
      loadLegacyStyles: false,
      mainPanel: ViewAll,
    },
    params: [],
  },
  {
    path: '/viewAll/users/:widgetName',
    name: 'ViewAllWithoutActions',
    meta: {
      title: 'Dashboard',
    },
    components: {
      loadLegacyStyles: false,
      mainPanel: ViewAllWithoutActions,
    },
    children: [
      {
        path: ':id',
        components: {
          loadLegacyStyles: false,
          mainPanel: ViewAllWithoutActions,
        },
      },
    ],
  },
  {
    path: '/viewall/devices/:widgetName',
    name: 'ViewAllDevices',
    meta: {
      title: 'Dashboard',
    },
    components: {
      loadLegacyStyles: false,
      mainPanel: ViewAllDevices,
    },
  },
  {
    path: '/deviceinvestigation',
    name: 'deviceinvestigation',
    meta: {
      title: 'Dashboard',
    },
    components: {
      loadLegacyStyles: false,
      mainPanel: DeviceInvestigativePages,
    },
  },

  // Investigative routes for widgets than users and devices
  {
    path: '/viewall/others/:widgetName',
    name: 'ViewAllOthers',
    meta: {
      title: 'Dashboard',
    },
    components: {
      loadLegacyStyles: false,
      mainPanel: ViewAllOthers,
    },
  },
];
